(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gkikz-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gkikz-collection-carousel')) {
    customElements.define('gkikz-collection-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.navigation = this.querySelector('[data-navigation]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.show(this.cards[event.key === 'Home' ? 0 : this.cards.length - 1]);
          }
        }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const card = this.cards.find(item => item.dataset.blockId === event.detail.blockId);
          if (card) this.show(card);
        }, { signal });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      distance(card) {
        const style = getComputedStyle(this.track);
        const track = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        return style.direction === 'rtl' ? rect.right - track.right + parseFloat(style.paddingRight) : rect.left - track.left - parseFloat(style.paddingLeft);
      }
      show(card) {
        this.track.scrollBy({ left: this.distance(card), behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
      move(step) {
        let index = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => { const value = Math.abs(this.distance(card)); if (value < distance) { index = i; distance = value; } });
        this.show(this.cards[Math.max(0, Math.min(this.cards.length - 1, index + step))]);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.navigation.hidden = max <= 2;
        this.previous.disabled = offset <= 2;
        this.next.disabled = offset >= max - 2;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkikz-featured-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gkikz-featured-carousel')) {
    customElements.define('gkikz-featured-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.cards = Array.from(this.querySelectorAll('[data-card]'));
        if (!this.track || !this.cards.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.previous = this.querySelector('[data-previous]');
        this.next = this.querySelector('[data-next]');
        this.navigation = this.querySelector('[data-navigation]');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.previous.addEventListener('click', () => this.move(-1), { signal });
        this.next.addEventListener('click', () => this.move(1), { signal });
        this.track.addEventListener('scroll', () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
        }, { passive: true, signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          const rtl = getComputedStyle(this.track).direction === 'rtl';
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
          } else if (event.key === 'Home' || event.key === 'End') {
            event.preventDefault();
            this.show(this.cards[event.key === 'Home' ? 0 : this.cards.length - 1]);
          }
        }, { signal });
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(this.track);
        this.update();
      }
      distance(card) {
        const style = getComputedStyle(this.track);
        const track = this.track.getBoundingClientRect();
        const rect = card.getBoundingClientRect();
        return style.direction === 'rtl' ? rect.right - track.right + parseFloat(style.paddingRight) : rect.left - track.left - parseFloat(style.paddingLeft);
      }
      show(card) {
        this.track.scrollBy({ left: this.distance(card), behavior: this.reducedMotion.matches ? 'instant' : 'smooth' });
      }
      move(step) {
        let index = 0;
        let distance = Infinity;
        this.cards.forEach((card, i) => { const value = Math.abs(this.distance(card)); if (value < distance) { index = i; distance = value; } });
        this.show(this.cards[Math.max(0, Math.min(this.cards.length - 1, index + step))]);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const offset = Math.abs(this.track.scrollLeft);
        this.navigation.hidden = max <= 2;
        this.previous.disabled = offset <= 2;
        this.next.disabled = offset >= max - 2;
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkikz-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gkikz-hero-slideshow')) {
    customElements.define('gkikz-hero-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        if (!this.slides.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.index = 0;
        this.visible = false;
        this.hovered = false;
        this.focused = false;
        this.editorSelected = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.mobile = matchMedia('(max-width: 749px)');
        this.paused = this.reducedMotion.matches;
        this.motion = this.querySelector('[data-motion]');
        this.addEventListener('click', event => {
          if (this.suppressClick) { event.preventDefault(); this.suppressClick = false; return; }
          if (event.target.closest('[data-next]')) this.select(this.index + 1);
          if (event.target.closest('[data-previous]')) this.select(this.index - 1);
          if (event.target.closest('[data-motion]')) { this.paused = !this.paused; this.sync(); }
          if (event.target.closest('[data-video-play]')) {
            this.paused = false;
            this.playVideo(true);
            this.syncControls();
            this.schedule();
          }
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
          event.preventDefault();
          this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
        }, { signal });
        this.addEventListener('pointerdown', event => {
          if (event.pointerType === 'mouse' || event.target.closest('button, a')) return;
          this.pointer = { x: event.clientX, y: event.clientY };
        }, { signal });
        this.addEventListener('pointerup', event => {
          if (!this.pointer) return;
          const dx = event.clientX - this.pointer.x;
          const dy = event.clientY - this.pointer.y;
          this.pointer = null;
          if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
            this.suppressClick = true;
            this.select(this.index + (dx < 0 ? 1 : -1));
            clearTimeout(this.swipeTimer);
            this.swipeTimer = setTimeout(() => { this.suppressClick = false; }, 400);
          }
        }, { signal });
        this.addEventListener('pointercancel', () => { this.pointer = null; }, { signal });
        this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.schedule(); } }, { signal });
        this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, { signal });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, { signal });
        this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); } }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.mobile.addEventListener('change', () => this.sync(), { signal });
        this.reducedMotion.addEventListener('change', event => { this.paused = event.matches; this.sync(); }, { signal });
        document.addEventListener('shopify:block:select', event => {
          const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.editorSelected = true;
          this.select(index);
        }, { signal });
        document.addEventListener('shopify:block:deselect', event => {
          if (!this.slides.some(slide => slide.dataset.blockId === event.detail.blockId)) return;
          this.editorSelected = false;
          this.schedule();
        }, { signal });
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.sync();
        }, { threshold: .1 });
        this.observer.observe(this);
        this.syncControls();
      }
      select(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.slides.forEach((slide, i) => {
          const active = i === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.inert = !active;
        });
        const current = this.querySelector('[data-current]');
        if (current) current.textContent = String(this.index + 1).padStart(2, '0');
        this.sync();
      }
      activeVideo() {
        return Array.from(this.slides[this.index].querySelectorAll('video')).find(video => {
          if (video.classList.contains('gk-hero__video--mobile')) return this.mobile.matches;
          if (video.classList.contains('gk-hero__video--desktop')) return !this.mobile.matches;
          return true;
        });
      }
      playVideo(force = false) {
        const active = this.activeVideo();
        const slide = this.slides[this.index];
        const fallback = slide.querySelector('[data-video-play]');
        this.querySelectorAll('video').forEach(video => { if (video !== active) video.pause(); });
        if (!active) return;
        if (!force && (this.paused || !this.visible || document.hidden)) {
          active.pause();
          if (fallback) fallback.hidden = !this.paused;
          return;
        }
        active.muted = true;
        const promise = active.play();
        if (promise) promise.then(() => {
          if (active !== this.activeVideo() || !this.visible || document.hidden || this.paused) { active.pause(); return; }
          if (fallback) fallback.hidden = true;
        }).catch(() => { if (active === this.activeVideo() && fallback) fallback.hidden = false; });
      }
      syncControls() {
        if (!this.motion) return;
        this.motion.hidden = (this.dataset.autoplay !== 'true' || this.slides.length < 2) && !this.activeVideo();
        this.motion.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
        this.motion.setAttribute('aria-pressed', String(this.paused));
        this.motion.querySelector('[data-play-icon]').toggleAttribute('hidden', !this.paused);
        this.motion.querySelector('[data-pause-icon]').toggleAttribute('hidden', this.paused);
      }
      schedule() {
        clearTimeout(this.timer);
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || !this.visible || document.hidden || this.hovered || this.focused || this.editorSelected) return;
        this.timer = setTimeout(() => this.select(this.index + 1), Number(this.dataset.interval) || 7000);
      }
      sync() { this.playVideo(); this.syncControls(); this.schedule(); }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        clearTimeout(this.timer);
        clearTimeout(this.swipeTimer);
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkikz-product-spotlight"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gkikz-product-spotlight')) {
    customElements.define('gkikz-product-spotlight', class extends HTMLElement {
      connectedCallback() {
        if (this.abortController) return;
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('.gk-spotlight__video-toggle');
        if (!this.video || !this.toggle) return;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = !('IntersectionObserver' in window);
        this.userPaused = false;
        this.blocked = false;
        this.failed = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.video.playsInline = true;
        this.updateControl = () => {
          const playing = !this.video.paused && !this.video.ended;
          this.toggle.toggleAttribute('data-playing', playing);
          this.toggle.setAttribute('aria-label', playing ? this.toggle.dataset.pauseLabel : this.toggle.dataset.playLabel);
        };
        this.video.addEventListener('play', this.updateControl, options);
        this.video.addEventListener('pause', this.updateControl, options);
        this.video.addEventListener('ended', this.updateControl, options);
        this.video.addEventListener('error', () => {
          this.failed = true;
          this.querySelector('.gk-spotlight__media').setAttribute('data-video-error', '');
          this.toggle.hidden = true;
          const status = this.querySelector('[data-video-status]');
          status.textContent = status.dataset.errorLabel;
        }, options);
        this.toggle.addEventListener('click', () => {
          if (this.video.paused) {
            this.userPaused = false;
            this.blocked = false;
            this.playVideo();
          } else {
            this.userPaused = true;
            this.video.pause();
          }
        }, options);
        this.syncPlayback = () => {
          if (!this.inView || document.hidden || this.motion.matches) {
            this.video.pause();
          } else if (this.dataset.autoplay === 'true' && !this.userPaused && !this.blocked) {
            this.playVideo();
          }
        };
        document.addEventListener('visibilitychange', this.syncPlayback, options);
        this.motion.addEventListener('change', this.syncPlayback, options);
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.25;
            this.syncPlayback();
          }, { threshold: [0, 0.25] });
          this.observer.observe(this.video);
        }
        this.video.controls = false;
        this.toggle.hidden = false;
        this.updateControl();
      }
      playVideo() {
        if (this.failed || this.playPending || !this.video.paused) return;
        this.playPending = true;
        this.video.play().then(() => {
          if (!this.isConnected || document.hidden || !this.inView || this.userPaused) this.video.pause();
        }).catch(() => {
          this.blocked = true;
        }).finally(() => {
          this.playPending = false;
          this.updateControl();
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.abortController?.abort();
        this.video?.pause();
        this.abortController = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gkikz-shop-the-look"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gk-shop-look')) {
    customElements.define('gk-shop-look', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.cards = [...this.querySelectorAll('[data-look-card]')];
        this.buttons = [...this.querySelectorAll('[data-look-select]')];
        this.status = this.querySelector('.gk-look__status');
        if (!this.cards.length) return;
        const options = { signal: this.events.signal };
        this.addEventListener('click', event => {
          const button = event.target.closest('[data-look-select]');
          if (button && this.contains(button)) this.select(button.dataset.lookSelect);
        }, options);
        this.addEventListener('keydown', event => {
          const button = event.target.closest('[data-look-select]');
          if (!button || !['ArrowRight', 'ArrowLeft', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const index = this.cards.findIndex(card => card.dataset.lookCard === button.dataset.lookSelect);
          let next = event.key === 'ArrowRight' ? index + 1 : index - 1;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.cards.length - 1;
          const card = this.cards[(next + this.cards.length) % this.cards.length];
          this.select(card.dataset.lookCard);
          const isSpot = button.classList.contains('gk-look__spot');
          this.buttons.find(item => item.dataset.lookSelect === card.dataset.lookCard && item.classList.contains('gk-look__spot') === isSpot)?.focus({ preventScroll: true });
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const card = event.target.closest('[data-look-card]');
          if (card) this.select(card.dataset.lookCard);
        }, options);
        this.select(this.cards[0].dataset.lookCard, false);
        this.setAttribute('data-ready', '');
      }
      select(id, announce = true) {
        const selected = this.cards.find(card => card.dataset.lookCard === id);
        if (!selected) return;
        this.cards.forEach(card => card.classList.toggle('is-selected', card === selected));
        this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lookSelect === id)));
        if (announce && this.status) this.status.textContent = selected.dataset.lookTitle;
      }
      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
